import React, { useState, useEffect } from "react";
import { Urls } from "../../Urls";
import axios from "../../Axios";
import "./TransportComparison.css";
import Loader from "../Loader";
// import axios2 from 'axios'
// import transporter_alt from '../../Content/images/transporter_logo.png'
import ReactGA from "react-ga";
import {
  useAppContext,
  ContextConstants,
} from "../UserContext/TransporterCompareContext";
import deepClone from "lodash.clonedeep";
import { getImageSrc, imageFallBack } from "../../Utility";
import {
  Activity,
  ActivityString,
  currentRequestTimeStamp,
} from "../../Constants";
import { toast } from "react-toastify";

const TransportComparison = ({ props, from_search, lsp_ids }) => {
  ReactGA.pageview("CompareNow");
  useEffect(() => {
    // console.log(lsp_ids)
    // console.log(from_search)
    // currentCompareList(lsp_ids);
  }, [from_search]);

  const {
    tableKeys,
    tableData,
    key_name,
    dispatch,
    currentList = [],
  } = useAppContext();

  const [show, setShow] = useState(false);
  const [width, setwidth] = useState(
    window.innerWidth > 0 ? window.innerWidth : Screen.width,
  );

  const loadInitialData = (dispatch) => {
    setShow(true);
    dispatch({ type: ContextConstants.resetState });
    axios
      .get(`${Urls.CompareUrl}`)
      .then((res) => {
        // console.log(dispatch)
        let initialData = [];
        let newTableKeys = [];
        dispatch({
          type: ContextConstants.getKeys,
          payload: res.data,
        });

        res.data.map((item) => {
          item[Object.keys(item)].map((inneritem) => {
            newTableKeys.push({
              ...deepClone(inneritem),
            });
            initialData.push({
              value: inneritem.toUpperCase(),
              description: inneritem,
            });
          });
        });
        
        dispatch({
          type: ContextConstants.setTableKeys,
          payload: newTableKeys,
        });
        
        setShow(false);
        
        let newTableData = [{
          ...deepClone({
            transporter_id: "main_header",
            compare_features: initialData,
          }),
        }];

        dispatch({
          type: ContextConstants.add,
          payload: newTableData,
        });
        
        // old code
        // currentCompareList();
        if (from_search) {
          currentCompareList(newTableData);
        } else {
          currentCompareList(newTableData);
        }
      })
      .catch((err) => {
        console.log(err);
        setShow(false);
      });
  };
  const currentCompareList = (baseTableData) => {
    // console.log(tableData)
    const dataToUse = baseTableData || tableData;
    let newTableData = [...dataToUse];

    if (from_search) {
      var queryString = "";
      from_search.map((item) => {
        queryString += `transporter_id=${item.transporter_id}&`;
      });
      if (queryString.length > 0) {
        queryString = queryString.substring(0, queryString.length - 1);
        setShow(true);
        axios
          .get(`${Urls.CompareUrl}?${queryString}`)
          .then((res) => {
            res.data.map((transporter) => {
              if (transporter["compare_features"]) {
                newTableData.push({
                  ...deepClone(transporter),
                });
              } else {
                toast.info("You are running out of credits!");
              }
            });
            dispatch({
              type: ContextConstants.add,
              payload: newTableData,
            });

            setShow(false);
          })
          .catch((err) => {
            console.log(err);
            setShow(false);
          });
      }
    } else {
      var queryString = "";
      currentList.map((item) => {
        queryString += `transporter_id=${item.transporter_id}&`;
      });
      if (queryString.length > 0) {
        queryString = queryString.substring(0, queryString.length - 1);
        setShow(true);
        axios
          .get(`${Urls.CompareUrl}?${queryString}`)
          .then((res) => {
            res.data.map((transporter) => {
              if (transporter["compare_features"]) {
                newTableData.push({
                  ...deepClone(transporter),
                });
              } else {
                toast.info("You are running out of credits!");
              }
            });
            dispatch({
              type: ContextConstants.add,
              payload: newTableData,
            });

            setShow(false);
          })
          .catch((err) => {
            console.log(err);
            setShow(false);
          });
      }
    }
  };
  useEffect(() => {
    // console.log(dispatch)
    loadInitialData(dispatch);

    Activity([
      {
        screen: "CompareNow",
        module: "CompareNow",
        user_activity: ActivityString.CompareNowPageView,
        timestamp: currentRequestTimeStamp(),
      },
    ]);
  }, []);

  // const getBlobUrl = (fileid) => {
  //     return axios2.get(`${Urls.blobUrl}?action=download&request_timestamp=${(new Date()).toISOString()}&filename=${fileid}`)
  //         .then(res => {
  //             if (res.data.fileid.length > 1)
  //                 return res.data.url
  //             else
  //                 return transporter_alt
  //         })
  //         .catch(Err => transporter_alt)
  // }

  const renderData = (value, description) => {
    if (description !== "Logo") {
      if (typeof value === "object") {
        return (
          <ol>
            {" "}
            {value.map((item, index) => (
              <li key={index} className="table-list">
                {item.toUpperCase()}
              </li>
            ))}
          </ol>
        );
      } else return value.toUpperCase();
    } else {
      return value === "LOGO" ? (
        "LOGO"
      ) : (
        <img
          alt="img"
          src={getImageSrc(value)}
          onError={(e) => imageFallBack(e)}
          className="transporter_logo_comparision mx-auto d-block "
        />
      );
    }
  };

  const renderData2 = (value, description, transporter_name, table_number) => {
    if (description !== "Logo") {
      if (typeof value === "object") {
        return (
          <>
            <div>
              <div
                style={{ paddingBottom: "1%", textAlign: "center" }}
                className={table_number === 0 ? "bold_text" : ""}
              >
                <label>{table_number !== 0 ? transporter_name : null}</label>
              </div>
              <div style={{ textAlign: "center" }}>
                <ol>
                  {" "}
                  {value.map((item, index) => (
                    <li key={index} className="table-list">
                      {item.toUpperCase()}
                    </li>
                  ))}
                </ol>
              </div>
            </div>
          </>
        );
      } else
        return (
          <>
            <div>
              <div
                style={{ paddingBottom: "1%", textAlign: "center" }}
                className={table_number === 0 ? "bold_text" : ""}
              >
                <label>
                  {table_number !== 0 &&
                  description.toUpperCase() !== "Transporter Name".toUpperCase()
                    ? transporter_name
                    : null}
                </label>
              </div>
              <div style={{ textAlign: "center" }}>{value.toUpperCase()}</div>
            </div>
          </>
        );
    } else {
      return value === "LOGO" ? (
        "LOGO"
      ) : (
        <>
          {table_number !== 0 ? transporter_name : null}
          <img
            alt="img"
            src={getImageSrc(value)}
            onError={(e) => imageFallBack(e)}
            className="transporter_logo_comparision mx-auto d-block "
          />
        </>
      );
    }
  };

  const createTableBody = (tableData, currentKeys, tablenumber) => {
    // console.clear()
    // console.log(tableData)
    // console.log(currentKeys)
    // console.log(tablenumber)
    return tableKeys.map((compareItem, compareIndex) => {
      return (
        <div key={compareIndex} className="row table_row">
          {tableData.map((transporterItem, transporterIndex) => {
            if (
              transporterItem.compare_features &&
              transporterItem.compare_features[compareIndex] &&
              transporterItem.compare_features[compareIndex].description
                ? currentKeys.includes(
                    transporterItem.compare_features[compareIndex].description,
                  )
                : null
            )
              return (
                <div
                  key={transporterIndex}
                  className="td-color col-xl-3 col-lg-3 col-md-3 col-sm-12 table_column"
                  id={`${transporterItem.transporter_id}`}
                >
                  {tablenumber === 0 &&
                  compareIndex === 0 &&
                  transporterItem.transporter_id !== "main_header" ? (
                    shouldDelete(window.location.pathname) ? (
                      <button
                        type="button"
                        className="transporter_close_button"
                        onClick={(e) =>
                          deleteColumn(transporterItem.transporter_id)
                        }
                      >
                        x
                      </button>
                    ) : null
                  ) : null}
                  {width > 1200
                    ? renderData(
                        transporterItem.compare_features[compareIndex].value,
                        transporterItem.compare_features[compareIndex]
                          .description,
                      )
                    : renderData2(
                        transporterItem.compare_features[compareIndex].value,
                        transporterItem.compare_features[compareIndex]
                          .description,
                        transporterItem.compare_features[1].value,
                        transporterIndex,
                      )}
                </div>
              );
          })}
        </div>
      );
    });
  };

  const shouldDelete = (path) => {
    if (path.includes("/DiscoverNow")) return false;
    else return true;
  };

  const deleteColumn = async (id) => {
    // console.log(tableData.length)
    if (tableData.length === 2) {
      dispatch({
        type: ContextConstants.removetransporter,
        payload: [],
      });
      dispatch({
        type: ContextConstants.removeTransporterFromList,
        payload: [],
      });
    } else {
      dispatch({
        type: ContextConstants.removetransporter,
        payload: tableData.filter((item) => item.transporter_id !== id),
      });
      dispatch({
        type: ContextConstants.removeTransporterFromList,
        payload: currentList.filter((item) => item.transporter_id !== id),
      });
    }
    // dispatch({
    //     type: ContextConstants.removetransporter,
    //     payload: tableData.filter(item => item.transporter_id !== id),

    // })
    // dispatch({
    //     type: ContextConstants.removeTransporterFromList,
    //     payload: currentList.filter(item => item.transporter_id !== id)

    // })
  };

  return (
    <div
      className="container-fluid"
      style={{ height: "90vh", overflow: "auto" }}
    >
      <Loader show={show} message="Loading Details" />
      <div className="row">
        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 shadow left-div-content left-parameter-fixed">
          <span className="d-none d-sm-block selection-bar">
            <h4 className="comparison-header-parameter">
              <center>
                <u>
                  <b>Parameters</b>
                </u>
              </center>
            </h4>

            <nav
              id="navbar-example3"
              className="navbar navbar-light bg-light parameters"
            >
              <nav className="nav nav-pills flex-column">
                <a
                  className="nav-link nav-font"
                  href="#General Information"
                  data-toggle="collapse"
                  data-target="#collapse-1"
                >
                  <i className="fas fa-info-circle"></i>
                  <b> General Information</b>
                </a>
                <div id="collapse-1" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a
                      className="nav-link ml-3 my-1"
                      href="#General Information"
                    >
                      Website
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#General Information"
                    >
                      Established
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#General Information"
                    >
                      Market Intelligence
                    </a>
                  </nav>
                </div>
                <a
                  className="nav-link nav-font"
                  href="#Financials (in Crore)"
                  data-toggle="collapse"
                  data-target="#collapse-2"
                >
                  <i className="fas fa-hand-holding-usd"></i>
                  <b> Financials</b>
                </a>
                <div id="collapse-2" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Financials (in Crore)"
                    >
                      Turnover
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Financials (in Crore)"
                    >
                      Net Profit
                    </a>
                  </nav>
                </div>
                <a
                  className="nav-link nav-font"
                  href="#Business Parameters"
                  data-toggle="collapse"
                  data-target="#collapse-3"
                >
                  <i className="fas fa-briefcase"></i>
                  <b> Business Parameters</b>
                </a>
                <div id="collapse-3" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Business Parameters"
                    >
                      Company type
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Business Parameters"
                    >
                      Modes of Transportation
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Business Parameters"
                    >
                      Industry Served
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Business Parameters"
                    >
                      GST Registered
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Business Parameters"
                    >
                      Bank Approved
                    </a>
                  </nav>
                </div>
                <a
                  className="nav-link nav-font"
                  href="#Operational Overview"
                  data-toggle="collapse"
                  data-target="#collapse-4"
                >
                  <i className="fas fa-truck-loading"></i>
                  <b> Operational Overview</b>
                </a>
                <div id="collapse-4" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Operational Overview"
                    >
                      Area of Operation
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Operational Overview"
                    >
                      No. of Branches
                    </a>
                    {/* <a className="nav-link ml-3 my-1" href="#item-4-3">Lanes of Operation Map</a> */}
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Operational Overview"
                    >
                      Truck/Asset Details
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Operational Overview"
                    >
                      Manpower Details
                    </a>
                    <a
                      className="nav-link ml-3 my-1"
                      href="#Operational Overview"
                    >
                      Warehousing Capability
                    </a>
                  </nav>
                </div>
                <a
                  className="nav-link nav-font"
                  href="#Customer Details"
                  data-toggle="collapse"
                  data-target="#collapse-5"
                >
                  <i className="fas fa-users"></i>
                  <b> Customer Details</b>
                </a>
                <div id="collapse-5" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a className="nav-link ml-3 my-1" href="#Customer Details">
                      Customers Served
                    </a>
                    {/* <a className="nav-link ml-3 my-1" href="#Customer Details">Companies wished to work with</a> */}
                  </nav>
                </div>
                <a
                  className="nav-link nav-font"
                  href="#Miscellaneous"
                  data-toggle="collapse"
                  data-target="#collapse-6"
                >
                  <i className="fas fa-paperclip"></i>
                  <b> Miscellaneous</b>
                </a>
                <div id="collapse-6" className="collapse">
                  <nav className="nav nav-pills flex-column">
                    <a className="nav-link ml-3 my-1" href="#Miscellaneous">
                      Acceptable Terms
                    </a>
                    <a className="nav-link ml-3 my-1" href="#Miscellaneous">
                      Other Business Interests
                    </a>
                    <a className="nav-link ml-3 my-1" href="#Miscellaneous">
                      Value Added Services
                    </a>
                    <a className="nav-link ml-3 my-1" href="#Miscellaneous">
                      Shipment Tracking Method
                    </a>
                  </nav>
                </div>
              </nav>
            </nav>
          </span>
        </div>
        <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-xs-12 right-comparison-parameters">
          {/* <div className="select-style-comparison col-xl-4 col-lg-4 col-sm-12">
                        <h4 className="add-transporter-header">Select Transporters for comparison</h4>
                        <div className="compare-select">
                            <VirtualizedSelect value={selectedValue} onChange={selectValue => { addColumn(selectValue) }} options={options} />
                        </div>
                        <div>
                            <span><i>*You can compare 3 transporters simultaneously</i></span>
                        </div>
                        <button className="btn btn-primary" onClick={e => addColumn()}>Add Transporter</button>
                    </div> */}
          <div>
            {key_name.map((item, index) => {
              return (
                <div key={index} className="container-fluid">
                  <span id={Object.keys(item)[0]}>
                    <h4 className="comparison-header-parameter">
                      {Object.keys(item)[0]}
                    </h4>
                  </span>
                  {createTableBody(
                    tableData,
                    item[Object.keys(item)[0]],
                    index,
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportComparison;
